











export default {
  name: 'text-input',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: String
  }
}
